import { IViewCategoryContext } from './viewCategoryContext';

export enum ViewCategoryActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_CATEGORY_FULL_INFO = 'SET_CATEGORY_FULL_INFO',
	SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS = 'SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS',
	SET_RESTAURANT_PROPS = 'SET_RESTAURANT_PROPS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: ViewCategoryActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IViewCategoryContext['needRefetchData'];
	};
}

interface ISetCategoryFullInfo {
	type: ViewCategoryActionTypes.SET_CATEGORY_FULL_INFO;
	payload: {
		categoryFullInfo: IViewCategoryContext['categoryFullInfo'];
		accessibleRestaurants: IViewCategoryContext['accessibleRestaurants'];
	};
}

interface ISetRestaurantIdForRestaurantProps {
	type: ViewCategoryActionTypes.SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS;
	payload: {
		restaurantIdForRestaurantProps: IViewCategoryContext['restaurantIdForRestaurantProps'];
		restaurantProps: IViewCategoryContext['restaurantProps'];
	};
}

interface ISetRestaurantProps {
	type: ViewCategoryActionTypes.SET_RESTAURANT_PROPS;
	payload: {
		restaurantProps: IViewCategoryContext['restaurantProps'];
	};
}

interface ISetTranslationTab {
	type: ViewCategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IViewCategoryContext['selectedTranslationTab'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ViewCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IViewCategoryContext['typeOfModalWindow'];
	};
}

export type TViewCategoryAction =
	| IRefetchData
	| ISetCategoryFullInfo
	| ISetRestaurantIdForRestaurantProps
	| ISetRestaurantProps
	| ISetTranslationTab
	| IChangeTypeOfModalWindow;
